import { Component, Input } from '@angular/core'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { expandCollapse, openClose } from '../../animations/open-close-animations'
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap'
import { PrePostCapitalStructureComponent } from '../prepost-capital-structure/prepost-capital-structure.component'
import { InstrumentViewComponent } from '../instrument-view/instrument-view.component'
import { InterestRatesComponent } from '../interest-rates/interest-rates.component'
import { NgTemplateOutlet, CurrencyPipe, DatePipe } from '@angular/common'

@Component({
    animations: [
        openClose,
        expandCollapse
    ],
    selector: 'capital-structure',
    templateUrl: './capital-structure.component.html',
    styleUrls: ['./capital-structure.component.scss'],
    imports: [NgTemplateOutlet, NgxBootstrapIconsModule, InterestRatesComponent, InstrumentViewComponent, PrePostCapitalStructureComponent, NgbTooltip, CurrencyPipe, DatePipe]
})
export class CapitalStructureComponent {
  @Input() capitalstructure: any = {}
  @Input() instrumentIDLookup: any = {}
  @Input() situationType: string = 'bankruptcy'
  @Input() classesLookup: any = {}
  @Input() expandAll: boolean = false
  @Input('expandID') set expandID(id:string) {
    if (id?.length > 0) {
      this.isExpanded[id] = true
      this.expandIDString = id
    }
  }

  public isExpanded: Dictionary<boolean> = {}
  public iconNames = IconNamesEnum
  public expandIDString = ''
}